import React from "react";
import * as Icons from "lucide-react";
import { STACK } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function Stack() {
  const r = useReveal();
  return (
    <section id="stack" className="bg-ls py-20 md:py-28">
      <div ref={r.ref} className={`max-w-5xl mx-auto px-5 md:px-8 ${r.className}`}>
        <p className="ls-eyebrow mb-4">Here's the deal…</p>
        <h2 className="font-display text-white text-[9vw] sm:text-5xl md:text-6xl max-w-4xl">
          You don't want more software.{" "}
          <span className="text-orange">You want more booked jobs.</span>
        </h2>
        <p className="mt-5 text-lg text-[#c7bdae] max-w-3xl">
          This isn't a pile of random tools. It's one simple setup where everything works together, so nothing falls
          through the cracks. That's the whole reason it works.
        </p>

        {/* Clean, un-boxed list — one warm column of what you actually get */}
        <div className="mt-12 divide-y" style={{ borderColor: "var(--ls-border)" }}>
          {STACK.map((item) => {
            const Icon = Icons[item.icon] || Icons.Box;
            return (
              <div
                key={item.n}
                className="warm-divider flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-6 py-7 group"
              >
                <div className="flex items-center gap-4 sm:w-56 shrink-0">
                  <span
                    className="flex items-center justify-center w-12 h-12 rounded-2xl shrink-0"
                    style={{ backgroundColor: "rgba(242,106,33,0.14)" }}
                  >
                    <Icon className="w-5 h-5 text-orange" />
                  </span>
                  <h3 className="font-cond font-extrabold text-2xl text-white uppercase tracking-wide leading-none">
                    {item.title}
                  </h3>
                </div>
                <div className="flex-1">
                  <p className="text-[17px] text-[#d7cdbf] leading-relaxed">{item.body}</p>
                  <p className="mt-1.5 text-sm">
                    <span className="text-orange font-semibold">Fixes:</span>{" "}
                    <span className="text-[#a99f92]">{item.solves}</span>
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <p className="mt-10 text-lg text-[#d7cdbf] max-w-2xl leading-relaxed">
          Put together, this quietly works in the background to bring you more business over time — while you're out
          doing the actual work.
        </p>
      </div>
    </section>
  );
}
